import React, { useState } from 'react';
import SosFromChild from '../modals/SosFromChild';
import moment from 'moment';
import { updateDashboardData } from '../../AxiosRtk/DashBoard';

const SoSIem = ({ item, getLangTranslation, getDashboardData }) => {
    const [showModal, setShowModal] = useState(false);
    const [sos, setSos] = useState(false);

    function closeModal() {
        setShowModal(false);
    }

    function sosCross() {
        setSos(true);
        const payload = {
            // "isEmailVerified": !item?.isEmailVerified ? 0 : 1,
            "receiveSosAlert": 1,
            "deviceId": item?.deviceId
        };
        updateDashboardData(payload)
            .then((res) => {
                getDashboardData();
            })
            .catch((err) => {
                console.log("update dashboard data catch error ===>>>", err?.response?.data?.message)
            })
            .finally(() => {
                setSos(false);
            })
    }

    return (
        <>
            <div className="col-md-12">
                <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3" role="alert">
                    <i
                        className='icon-info-octagon text-red-100 fs-5 c-pointer'
                        onClick={() => setShowModal(true)}
                    />
                    {getLangTranslation('PARENT_DASHBOARD_ALRET_SOS', 'SOS from child')}
                    <span className="light-text text-small">{moment(item['sosTime']).format("HH:mm - DD.MM.YY")}</span>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                        disabled={sos}
                        onClick={sosCross}
                    ></button>
                </div>
            </div>
            <SosFromChild
                showModal={showModal}
                closeModal={closeModal}
                dashData={item}
                getLangTranslation={getLangTranslation}
            />
        </>
    )
}

export default SoSIem